<style lang="scss" scoped>
.row {
    height: 395px;
}
</style>

<template>
    <div class="row">
        <div
            class="container-fluid bg-accent d-flex flex-column align-items-center justify-content-center px-32 px-lg-12 text-center"
        >
            <h2 class="text-white ">{{ title }}</h2>
            <div class="mt-32" v-if="cta_repeater">
                <template v-for="cta in cta_repeater">
                    <a
                        :href="cta.repeated_cta_link"                        
                        :class="cta.button_style"
                        class="mr-sm-16 mb-16 mb-sm-0"
                    >
                        {{ cta.repeated_cta_label }}
                    </a>
                    <br class="d-sm-none" />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "pageParts.large-cta-row",

    props: {
        title: {
            type: String,
            default: "Al goesting om het zelf te doen?"
        },
        cta_repeater: {
            type: Array,
            required: false
        }
    }
};
</script>
